import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Wheel Description:
 */
export class WheelDescription extends Component {
	static TypeName = 'wheel-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	wheelId: string = '';

	@property.material()
	paintMaterial: Material | null = null;

	@property.bool(false)
	isWireWheel!: boolean;
}
